import { render, staticRenderFns } from "./QaListItemComposeActions.vue?vue&type=template&id=3af2468a&scoped=true&"
import script from "./QaListItemComposeActions.vue?vue&type=script&lang=js&"
export * from "./QaListItemComposeActions.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemComposeActions.vue?vue&type=style&index=0&id=3af2468a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2468a",
  null
  
)

export default component.exports